module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "title-header"
  }, [_vm._v("尊敬的会员：")]), _vm._v(" "), _c('p', {
    staticClass: "tipinfo"
  }, [_vm._v(_vm._s(_vm.tipinfo) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "applycourse"
  }, [_vm._v("申请路径:" + _vm._s(_vm.applycourse))]), _vm._v(" "), _c('p', {
    staticClass: "downapp"
  }, [_vm._v("app下载二维码")]), _vm._v(" "), _c('div', {
    staticClass: "downloadQRcode"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0458f5da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/dialog/common/TipDialog.vue
// module id = K81n
// module chunks = 1